export default function initializePropPaneState(activeSet) {
  let rawToScaleScoring = {0: 0}
  if (activeSet.rawToScaleScoring) {
    rawToScaleScoring = activeSet.rawToScaleScoring
  } else if (activeSet.maxRaw) {
    // compute total possible raw score
    for (var i = 0; i <= activeSet.maxRaw; i++) {
      rawToScaleScoring[i] = 0
    }
  }

  let name = ''
  activeSet.name ? name = activeSet.name : null

  let directions = ''
  activeSet.directions ? directions = activeSet.directions : null

  // if (!activeSet.testType || activeSet.testType === 'None') {
  //   console.log('top')
  //   return {
  //     name,
  //     testType: 'None',
  //     nodeTag: '',
  //     timeLimit: 0,
  //     displayName: '',
  //     maxNodeLevels: 0,
  //     maxRaw: 0,
  //     rawToScaleScoring,
  //     directions: '',
  //     sectionBreaks: '',
  //     timeManagementEasy: '',
  //     timeManagementHard: '',
  //     precisionQuestions: '',
  //     precisionComparables: '',
  //     licensable: false,
  //     navName: '',
  //     navCategory: '',
  //     setType: 'None',
  //   }
  // } else {
  //   console.log('bottom')
    return {
      name,
      testType: activeSet.testType ? activeSet.testType : 'None',
      nodeTag: activeSet.nodeTag ? activeSet.nodeTag : '',
      timeLimit: activeSet.timeLimit ? activeSet.timeLimit : 0,
      displayName: activeSet.displayName ? activeSet.displayName : '',
      maxNodeLevels: activeSet.maxNodeLevels ? activeSet.maxNodeLevels : 0,
      maxRaw: activeSet.maxRaw ? activeSet.maxRaw : 0,
      rawToScaleScoring,
      directions,
      sectionBreaks: activeSet.sectionBreaks ? activeSet.sectionBreaks.join() : '',
      timeManagementEasy: activeSet.timeManagementEasy ? activeSet.timeManagementEasy.join() : '',
      timeManagementHard: activeSet.timeManagementHard ? activeSet.timeManagementHard.join() : '',
      precisionQuestions: activeSet.precisionQuestions ? activeSet.precisionQuestions.join() : '',
      precisionComparables: activeSet.precisionComparables ? activeSet.precisionComparables.join() : '',
      licensable: activeSet.licensable ? activeSet.licensable : false,
      navName: activeSet.navName ? activeSet.navName : '',
      navCategory: activeSet.navCategory ? activeSet.navCategory : '',
      setType: activeSet.setType ? activeSet.setType : 'None',
      template: activeSet.template ? activeSet.template : '',
    }
  // }
}


// WEBPACK FOOTER //
// ./src/helpers/content/manageSets/initializePropPaneState.js